import { empty } from '../../php-compat';
import type { PortEnv } from '../../port-contract';
import { isArray, values, slot, type Arr } from './access';
export interface LayerSourceDeps { ft_resolve_layer_entry(entry: unknown, caster: Arr): unknown; item_field(row: Arr, key: string): string | null; }
/** PHP: find_layer_source_item_id (includes/functions/janus/dice/resolve_adv_dis_layer_sources.php:162) */
export function findLayerSourceItemId(caster: Arr, layer: string, env: PortEnv<LayerSourceDeps>): string | null {
    for (const section of ['creature_type_arr', 'creature_sub_type_arr', 'lineage_arr', 'class_arr', 'subclass_arr', 'background_arr'])
        for (const entry of values((slot(caster, section) ?? []) as Arr)) {
            const row = env.deps.ft_resolve_layer_entry(entry, caster);
            if (!isArray(row)) continue;
            if (!empty(slot(row, layer))) return env.deps.item_field(row, 'item_id');
        }
    return null;
}
